// extracted by mini-css-extract-plugin
export default {"label":"styles-scoped__label--OlqTh","data":"styles-scoped__data--yPKEG"};